export const getTranslations = state => state.i18nState.translations;



// WEBPACK FOOTER //
// ./src/Setting/selectors.js